<template>
  <div>
    <timgname :params='params' :tabfrom='tabfrom'></timgname>
    <!-- <div class='model_div'>
      <div>{{tabfrom.title}}</div>
      <a-icon type="appstore" theme="filled" style='font-size: 1.2rem;' @click='ismodeltab = true'/></div>
      <modeltab @child='ismodeltab = false' :tabfrom='tabfrom' :ismodeltab='ismodeltab'></modeltab> -->
  </div>
</template>

<script>
  import modeltab from '@/components/modeltab/modeltab'

  export default{
    components:{modeltab},
    props:['isnum','params'],
    data(){
      return{
        newlist:[this.$lang.scjs , this.$lang.jyfs , this.$lang.fwsf],
        tabfrom:{
          typename:this.$lang.xjpg,
          title: '',
          taname: '',
          list: [this.$lang.scjs , this.$lang.jyfs , this.$lang.fwsf],
          urllist:['/sgsecurities_introduction','/sgsecurities_information','/sgsecurities_fees'],
        },
        ismodeltab:false,
      }
    },
    mounted(){
      this.tabfrom.taname = this.newlist[this.isnum]
      this.tabfrom.title = this.$lang.xjpg + ' • ' + this.tabfrom.taname;
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/xinjiapo/compoents/newtitle.vue